import {Link} from '@mui/material'
import {Link as RouterLink} from 'react-router-dom'
import analyticsService from 'services/analytic'

const OpenRow = ({value, rowData}) => {
    return (
        <Link
            component={RouterLink}
            to={`/client/${rowData.PlannerClientKey}`}
            onClick={() => analyticsService.clientsPressed('client')}>
            {value}
        </Link>
    )
}

export default OpenRow
